export default __webpack_public_path__ + "static/media/layer-fill.a9b3d910.svg";